export default "__VITE_ASSET__BbUx7Luy__"